import React from 'react';
import Konva from 'konva';
import { Text, Group, Image } from 'react-konva';
import AliasIcon from 'styles/icons/copy-synced-icon.svg';
import { color, typography } from 'styles/settings';

const aliasImage = new window.Image();
aliasImage.src = AliasIcon;

interface Props extends Konva.TextConfig {
  text: string;
  width: number;
  height?: number;
  x?: number;
  y?: number;
  align?: 'left' | 'right' | 'center';
  verticalAlign?: string;
  fontSize?: number;
  fill?: string;
  onDragEnd?: any;
  draggable?: any;
  wrap?: string;
  offsetX?: number;
  offsetY?: number;
  ellipsis?: boolean;
  isReference?: boolean | null;
}

const defaultProps = {
  x: 20,
  y: 0,
  height: 50,
  align: 'left',
  verticalAlign: 'middle',
  fontFamily: typography.font.fontFamily,
  fontStyle: 'bold',
  fontSize: 16,
  fill: color.neutral.gray,
  wrap: 'none',
  ellipsis: true,
};

function NodeHeader(props: Props) {
  function onMouseOver(event) {
    props.onMouseOver && props.onMouseOver(event);
  }

  return (
    <Group>
      {props.isReference && (
        <Image image={aliasImage} width={30} height={30} offsetY={35} />
      )}
      <Text
        {...props}
        {...(props.isReference ? { width: props.width - 35, x: 35 } : {})}
        onMouseOver={onMouseOver}
      />
    </Group>
  );
}

NodeHeader.defaultProps = defaultProps;

export default NodeHeader;
